export const environment = {
  production: false,
  webapi: 'https://api-operations.imagesound.com/',
  signaturePath: 'https://operations.imagesound.com/attachments/',
  signatureLocation: '\\\\10.10.0.4\\paperless_attachments_test\\',
  apikey: 'df9e7625-846a-4e59-9804-60bf8d31fd3e',
  maxFileSize: 524288000,
  googleAPIURL: 'https://www.googleapis.com/webfonts/v1/webfonts?key=',
  googleAPIKEY: 'AIzaSyA5f0JBHp_QjmNNXPbPe0hfj1NWdN3xA8E',
  refreshInterval: 120000,
  issuer: 'https://identity.imagesound.com',
  clientId: 'operations_paperless',
  application: 'Operations Portal',
  name: 'live',
  //attachment_path: 'paperless_attachments_test'
  // Roles for authentication
  allowed_engineer_roles: ['Administrator', 'Engineer','Project Manager']
};
